module.exports = __webpack_public_path__ + "img/1526323541.8c8e0dee.jpg";